import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/NewsModule/NewsModule.tsx");
